module.exports = "/**\n * Created by jv on 10/03/2017.\n */\n\n// (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n// (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n// m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n// })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n//\n// ga('create', 'UA-code-here', 'auto');\n// ga('set', 'anonymizeIp', true);\n\"use strict\";"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/babel-loader/lib!./~/eslint-loader!./app/js/misc/google-analytics.js
// module id = 914
// module chunks = 3